export * from './legend.component';
export * from './scale-legend.component';
export * from './legend-entry.component';
export * from './advanced-legend.component';
//# sourceMappingURL=index.js.map